<template>
  <div class="block-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="500px" :before-close="handleClose" :close-on-click-modal="false">
      <el-form ref="form" :model="params" :rules="rules" label-width="85px">
        <el-form-item label="IP:" prop="ip">
          <el-input v-model="params.ip" size="small"></el-input>
        </el-form-item>
        <el-form-item label="限制类型:" prop="type">
          <el-select v-model="params.type" :disabled="blockType!==''" clearable size="small">
            <el-option v-for="item in typeList" :key="item.code" :label="item.value" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注:" prop="remark">
          <el-input type="textarea" v-model="params.remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'

export default {
  data() {
    return {
      dialogVisible: false,
      title: '',
      flag: false,
      id: '',
      type: '',
      blockType: '',
      typeList: [
        { value: '发送评论限制', code: 'comment' },
        { value: '用户注册限制', code: 'login' },
        { value: '全局限制', code: 'global' },
      ],
      params: {
        ip: '',
        type: '',
        remark: '',
      },
      rules: {
        ip: [
          { required: true, message: '请输入IP', trigger: 'blur' },
        ],
        type: [
          { required: true, message: '请选择类型', trigger: 'blur' },
        ],
      }
    }
  },
  methods: {
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true
          if (this.type === 'add') {
            this.addBlock()
          } else {
            this.editBlock()
          }
        } else {
          return false;
        }
      });
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        ip: '',
        type: '',
        remark: '',
      }
      this.blockType = ''
      this.$refs['form'].resetFields()
    },
    // 打开限制弹窗、传递需要编辑的参数
    open(type, data) {
      this.type = type
      this.dialogVisible = true
      if (type === 'edit') {
        this.title = '编辑IP限制'
        this.params.ip = data.ip.join(',')
        this.params.remark = data.remark
        this.id = data.ID
        if (this.typeList.map(res => res.code).indexOf(data.type) !== -1) {
          this.params.type = data.type;
          this.blockType = data.type
        }
      } else {
        this.title = '新增IP限制'
      }

    },
    // 新增限制
    addBlock() {
      API.addIpBlock(this.params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '添加成功',
            type: 'success'
          });
          this.$emit('handlerClose')
        } else if (res.code === 5002) {
          this.$message.error('添加失败,已有该类型IP限制！')
        } else {
          this.$message.error('添加失败')
        }
        this.handleClose()
        this.flag = false
      }).catch(() => {
        this.handleClose();
        this.flag = false
      })
    },
    // 编辑限制
    editBlock() {
      let form = Object.assign({}, this.params, {
        Ip: this.params.ip.split(','),
        id: this.id
      })
      delete form.ip
      API.editIpBlock(form).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '编辑成功',
            type: 'success'
          });
          this.$emit('handlerClose')
        } else {
          this.$message.error('编辑失败');
        }
        this.handleClose();
        this.flag = false
      }).catch(() => {
        this.handleClose();
        this.flag = false
      })
    },
  }
}
</script>

<style lang="scss" >
.block-box {
  .el-input--small {
    width: 200px;
  }
  .el-select {
    width: 150px !important;
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border: 1px dashed #e63765;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>
